import { PropertyListingAddress } from "@components/PropertyListingAddress";
import { PropertyListingPrice } from "@components/PropertyListingPrice";
import { PropertyListingImage } from "@components/PropertyListingImage";
import type { PropertyListingsData } from "@gql";

import * as styles from "./PropertyListingTile.styles";

interface Props {
  propertyListing: Pick<
    PropertyListingsData["propertyListings"][0],
    | "bathroomTotal"
    | "bedroomsTotal"
    | "slug"
    | "unitNumber"
    | "addressLine1"
    | "city"
    | "province"
    | "postalCode"
    | "images"
    | "lease"
    | "leasePerTime"
    | "leasePerUnit"
    | "price"
  >;
}

const PropertyListingTile = ({ propertyListing }: Props) => {
  const renderBedNode = () => {
    if (propertyListing.bathroomTotal) {
      return (
        <span css={styles.bedAndBath} aria-label="number of bathrooms">
          <i className="fa fa-bath" /> {propertyListing.bathroomTotal}
        </span>
      );
    }
  };

  const renderBathNode = () => {
    if (propertyListing.bedroomsTotal) {
      return (
        <span css={styles.bedAndBath} aria-label="number of bedrooms">
          <i className="fa fa-bed" /> {propertyListing.bedroomsTotal}
        </span>
      );
    }
  };

  return (
    <div css={styles.propertyListingTileComponent} className="property-listing-tile-component">
      <a css={styles.link} href={`/property_listings/${propertyListing.slug}`}>
        <PropertyListingImage propertyListing={propertyListing} lazy />

        <div css={styles.details}>
          <PropertyListingAddress propertyListing={propertyListing} />
          <PropertyListingPrice propertyListing={propertyListing} />
          {renderBathNode()}
          {renderBedNode()}
        </div>
      </a>
    </div>
  );
};

export { PropertyListingTile };
